import moment from "moment";

/**
 * Staff-view UserId for Duplicate: unassigned must be `null`, never `0`.
 * @param {number|string|null|undefined} userId
 * @returns {number|string|null}
 */
export function resolveDuplicateStaffViewUserId(userId) {
  if (userId == null || userId === "" || Number(userId) === 0) {
    return null;
  }
  return userId;
}

/**
 * Builds the request body for POST /SchedulerEvent/Duplicate.
 *
 * @param {object} params
 * @param {number} params.schedulerEventId
 * @param {string|Date} params.eventDate
 * @param {number} [params.duplicateCount]
 * @param {boolean} [params.isStaffView] - true when duplicating from View by Staff Name
 * @param {number|string|null} [params.userId] - staff row user id; only sent when isStaffView is true
 */
export function buildDuplicateSchedulerEventPayload({
  schedulerEventId,
  eventDate,
  duplicateCount = 1,
  isStaffView = false,
  userId = null,
}) {
  const staffView = Boolean(isStaffView);

  return {
    SchedulerEventId: schedulerEventId,
    EventDate: moment(eventDate).format("YYYY-MM-DD"),
    DuplicateCount: Math.max(1, Number(duplicateCount) || 1),
    IsStaffView: staffView,
    UserId: staffView ? resolveDuplicateStaffViewUserId(userId) : null,
  };
}
